import { HttpClient } from '@angular/common/http';
import { inject, Injectable, resource } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Country } from '../models/country.model';
@Injectable({
    providedIn: 'root'
})
export class CountryService {
    private readonly http = inject(HttpClient);

    private readonly _countries = resource({
        defaultValue: [],
        loader: () => firstValueFrom(this.loadCountries())
    });

    get countries() {
        return this._countries.asReadonly();
    }

    private loadCountries(): Observable<Country[]> {
        return this.http.get<Country[]>(`${environment.apiUrl}/countries`);
    }
}
